import { useMemo } from "react"

import type { CellLookupProps } from "../components/RunsTableCells"

type BaseCellLookups = CellLookupProps

/**
 * Shared lookups passed to every cell renderer, memoized together so a change
 * to any one of them doesn't force every cell to re-render off a new object
 * identity from something else's remounting.
 */
export function useRunsTableCellLookups({
  agentNames,
  testSetNames,
  metricDisplayNames,
  metricRecordsById,
  personasById,
  getModelType,
  onAgentClick,
  onTestSetClick,
  onPersonaClick,
  resolveCreator,
}: BaseCellLookups): CellLookupProps {
  return useMemo(
    () => ({
      agentNames,
      testSetNames,
      metricDisplayNames,
      metricRecordsById,
      personasById,
      getModelType,
      onAgentClick,
      onTestSetClick,
      onPersonaClick,
      resolveCreator,
    }),
    [
      agentNames,
      testSetNames,
      metricDisplayNames,
      metricRecordsById,
      personasById,
      getModelType,
      onAgentClick,
      onTestSetClick,
      onPersonaClick,
      resolveCreator,
    ],
  )
}
